import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-observation-modal',
  templateUrl: './observation-modal.component.html',
  styleUrls: ['./observation-modal.component.css']
})

export class ObservationModal implements OnInit {
  constructor(
    public activeModal: NgbActiveModal,
  ){}

  @Input()
  data: any

  @Input()
  message: any;

  ngOnInit(){
  }

  confirmModal(type){
    this.activeModal.dismiss({ type: type })
  }

  downloadFile(){
    this.activeModal.dismiss({ type: 3 })
  }

}